import { render, staticRenderFns } from "./MainNavigation.vue?vue&type=template&id=fcf8bce6&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"
import style0 from "./MainNavigation.vue?vue&type=style&index=0&id=fcf8bce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf8bce6",
  null
  
)

export default component.exports